'use client';

import { MarketId } from '@drift/common';
import { useCurrentSlot } from 'src/hooks/useCurrentSlot';
import useMarketStateStore from 'src/stores/useMarketStateStore';
import { useL2Orderbook } from 'src/hooks/query/orderbook/useL2Orderbook';
import { useMarketPriceState } from 'src/hooks/query/orderbook/useMarketPriceState';

export const useTargetMarketSlotStaleness = (marketId: MarketId) => {
	const marketState = useMarketStateStore((s) =>
		s.getMarketDataForMarket(marketId)
	);

	const { data: l2Orderbook } = useL2Orderbook(marketId);
	const { data: marketPriceStateData } = useMarketPriceState(marketId);

	const currentSlot = useCurrentSlot();

	const orderbookSlot = l2Orderbook?.slot;
	const marketSlot = marketPriceStateData?.slot ?? 0;

	const l2Slot = orderbookSlot ?? 0;
	const oracleSlot = marketState?.oracle?.slot?.toNumber() ?? 0;
	const mmOracleSlot = marketState?.mmOracle?.slot?.toNumber() ?? 0;

	return {
		l2SlotStaleness: currentSlot - l2Slot,
		oracleSlotStaleness: currentSlot - oracleSlot,
		marketSlotStaleness: currentSlot - marketSlot,
		mmOracleSlotStaleness: currentSlot - mmOracleSlot,
	};
};
